import { SLOTS } from './slots.js'

// Quest submissions — a review pipeline. Primary is the submitter (links to the
// user's Social tab); the quest is the context. Rows carry the moderation
// context a moderator needs without opening each one: Example/rating tags,
// rejection reason, who reviewed it and when, how long it has waited, the
// moment's visibility and its full media — the display values (tags, review
// summary, waiting time, rejection label) are serialized by the server.
// Supports table, grid and board views.
// The page passes the server's per-tab emptyMessage.

export default {
  key: 'quest_submission',
  label: 'Quest Submission',
  icon: 'quest_submissions',
  columns: [
    {
      slot: SLOTS.PRIMARY,
      field: 'user.icon_image.image_url',
      renderer: 'avatar',
      labelField: 'user_label',
      label: 'User',
      // The submitter may have been deleted since; the serializer then sends `user: null`.
      link: 'user.url'
    },
    { slot: SLOTS.CONTEXT, field: 'quest_label', label: 'Quest', link: 'quest_url' },
    { slot: SLOTS.CONTEXT, field: 'quest.prompt', label: 'Prompt' },
    { slot: SLOTS.STATUS, field: 'state', label: 'Status', renderer: 'state_badge', domain: 'submission', tooltipField: 'review_summary' },
    {
      slot: SLOTS.STATUS,
      field: 'tags',
      label: 'Tags',
      renderer: 'tags',
      // The three ratings share one style, as the old CMS drew them.
      badges: {
        Example: { label: 'Example', badgeClass: 'badge-secondary' },
        Good: { label: 'Good', badgeClass: 'badge-warning' },
        Great: { label: 'Great', badgeClass: 'badge-warning' },
        Best: { label: 'Best', badgeClass: 'badge-warning' }
      }
    },
    { slot: SLOTS.STATUS, field: 'rejection_category_label', label: 'Rejection' },
    { slot: SLOTS.METADATA, field: 'rejection_reason', label: 'Reason' },
    { slot: SLOTS.STATUS, field: 'moment.visibility', label: 'Visibility', renderer: 'state_badge', domain: 'visibility' },
    { slot: SLOTS.METADATA, field: 'media', label: 'Media', renderer: 'moment_media', cardMedia: true },
    { slot: SLOTS.METADATA, field: 'place_label', label: 'Place', link: 'place.url' },
    {
      slot: SLOTS.METADATA,
      field: 'reviewed_by.name',
      label: 'Reviewed by',
      link: 'reviewed_by.url'
    },
    { slot: SLOTS.TEMPORAL, field: 'created_at', label: 'Submitted', renderer: 'date' },
    { slot: SLOTS.TEMPORAL, field: 'waiting_label', label: 'Waiting' },
    { slot: SLOTS.TEMPORAL, field: 'reviewed_at', label: 'Reviewed', renderer: 'date' }
  ],
  empty: { icon: 'quest_submissions', message: 'No submissions found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.STATUS] },
  grid: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.STATUS, SLOTS.METADATA], columns: 3 },
  board: { groupBy: 'state', laneOrder: ['submitted', 'approved', 'rejected'] }
}
